import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_tag = _resolveComponent("n-tag")!

  return (_ctx.asTag)
    ? (_openBlock(), _createBlock(_component_n_tag, {
        key: 0,
        size: "large",
        style: {"width":"6rem","justify-content":"center"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.displayedTime), 1)
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.displayedTime), 1))
}